"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
function default_1({ paymentDetail, paymentDetailDelivery, isSecondPayment, }) {
    let isRequirementsFulfilled = false;
    const { default_delivery, room_second_custom, second_customvalue, region } = paymentDetailDelivery;
    const { room_sns_type_cd_id, sns_account, room_is_refund_account, holder_name, 
    // user_holder_name,
    questions, user_agreements, } = paymentDetail;
    const hasAllRequiredAnswer = questions.every(({ is_required, is_image, answer_img_url, answer_text }) => !is_required || (is_image ? !!answer_img_url : !!answer_text));
    if (!default_delivery.phone_code) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('배송지 정보를 등록해 주세요') });
    }
    else if (room_second_custom && !second_customvalue) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('개인통관고유부호를 등록해 주세요') });
    }
    else if (region === 'KR' && room_second_custom && !default_delivery.en_address) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('배송지를 수정하여 영문 주소를 추가해주세요') });
    }
    else if (room_sns_type_cd_id !== 'ROOM_CUSTOMER_SNS_TYPE_00' && !sns_account) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('SNS 계정을 등록해 주세요') });
    }
    else if (room_is_refund_account && !holder_name) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('환불계좌를 등록해 주세요') });
    }
    else if (!hasAllRequiredAnswer) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('필수 답변을 등록해 주세요') });
    }
    else if (!isSecondPayment && !user_agreements) {
        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('주문 내용 동의 후 결제 가능해요') });
    }
    else {
        isRequirementsFulfilled = true;
    }
    return isRequirementsFulfilled;
}
exports.default = default_1;
